import { mapSuperannuationData } from './superstep-super-mapper';
import { mapTfnDeclarationData } from './superstep-tfn-mapper';

// Re-export constants for backward compatibility and external use
export {
  MAPPER_KEY,
  SUPER_PROGRESS_STATE_KEYS,
  TFN_OUTCOME_KEYS,
  SUPER_TYPE_KEYS,
  SUPER_SELF_MANAGED_FORM_UPLOAD_STATUSES,
  DECLARE_TRUE_AND_CORRECT_STATUSES,
} from './superstep-constants';

import { MAPPER_KEY } from './superstep-constants';

export const indexedMapper = {
  [MAPPER_KEY.SUPER_OPTION]: {
    labelTranslationKey: 'superannuation-option',
    value: null,
  },
  [MAPPER_KEY.SUPER_TYPE]: {
    labelTranslationKey: 'superannuation-type',
    value: null,
  },
  [MAPPER_KEY.SUPER_NAME]: {
    labelTranslationKey: 'superannuation-name',
    value: null,
  },
  [MAPPER_KEY.SUPER_TFN_NUMBER]: {
    labelTranslationKey: 'superannuation-tfn-number',
    value: null,
  },
  [MAPPER_KEY.SUPER_FUND]: {
    labelTranslationKey: 'superannuation-fund-name',
    value: null,
  },
  [MAPPER_KEY.SUPER_FUND_MEMBER]: {
    labelTranslationKey: 'superannuation-fund-member-number',
    value: null,
  },
  [MAPPER_KEY.SUPER_SELF_MANAGED_FORM]: {
    labelTranslationKey: 'superannuation-self-managed-form',
    value: null,
  },
  [MAPPER_KEY.SUPER_SMSF_FUND_ABN]: {
    labelTranslationKey: 'superannuation-smsf-fund-abn',
    value: null,
  },
  [MAPPER_KEY.SUPER_SMSF_FUND_NAME]: {
    labelTranslationKey: 'superannuation-smsf-fund-name',
    value: null,
  },
  [MAPPER_KEY.SUPER_SMSF_MEMBER_NUMBER]: {
    labelTranslationKey: 'superannuation-smsf-member-number',
    value: null,
  },
  [MAPPER_KEY.SUPER_SMSF_MEMBER_NAME]: {
    labelTranslationKey: 'superannuation-smsf-member-name',
    value: null,
  },
  [MAPPER_KEY.SUPER_SMSF_ELECTRONIC_SERVICE_ADDRESS]: {
    labelTranslationKey: 'superannuation-smsf-electronic-service-address',
    value: null,
  },
  [MAPPER_KEY.SUPER_SMSF_BANK_ACCOUNT_NUMBER]: {
    labelTranslationKey: 'superannuation-smsf-bank-account-number',
    value: null,
  },
  [MAPPER_KEY.SUPER_SMSF_BANK_ACCOUNT_NAME]: {
    labelTranslationKey: 'superannuation-smsf-bank-account-name',
    value: null,
  },
  [MAPPER_KEY.SUPER_SMSF_BANK_ACCOUNT_BSB]: {
    labelTranslationKey: 'superannuation-smsf-bank-account-bsb',
    value: null,
  },
  [MAPPER_KEY.SUPER_DECLARE_TRUE_AND_CORRECT]: {
    labelTranslationKey: 'superannuation-declare-true-and-correct',
    value: null,
  },
  [MAPPER_KEY.TFN_OPTION]: {
    labelTranslationKey: 'tfn-declaration-option',
    value: null,
  },
  [MAPPER_KEY.TFN_NUMBER]: {
    labelTranslationKey: 'tfn-declaration-number',
    value: null,
  },
  [MAPPER_KEY.TFN_REASON]: {
    labelTranslationKey: 'tfn-declaration-reason',
    value: null,
  },
  [MAPPER_KEY.TFN_PERSONAL_TITLE]: {
    labelTranslationKey: 'tfn-declaration-personal-title',
    value: null,
  },
  [MAPPER_KEY.TFN_PERSONAL_FULL_NAME]: {
    labelTranslationKey: 'tfn-declaration-personal-full-name',
    value: null,
  },
  [MAPPER_KEY.TFN_TAX_PAY_BASIS]: {
    labelTranslationKey: 'tfn-declaration-tax-pay-basis',
    value: null,
  },
  [MAPPER_KEY.TFN_TAX_RESIDENT_STATUS]: {
    labelTranslationKey: 'tfn-declaration-tax-resident-status',
    value: null,
  },
  [MAPPER_KEY.TFN_TAX_COUNTRY_OF_ORIGIN]: {
    labelTranslationKey: 'tfn-declaration-tax-country-of-origin',
    value: null,
  },
  [MAPPER_KEY.TFN_TAX_FREE_THRESHOLD]: {
    labelTranslationKey: 'tfn-declaration-tax-free-threshold',
    value: null,
  },
  [MAPPER_KEY.TFN_TAX_HAS_LOAN_OR_STUDENT_DEBT]: {
    labelTranslationKey: 'tfn-declaration-tax-has-loan-or-student-debt',
    value: null,
  },
  [MAPPER_KEY.TFN_TAX_DECLARE_TRUE_AND_CORRECT]: {
    labelTranslationKey: 'tfn-declaration-tax-declare-true-and-correct',
    value: null,
  },
};

/**
 * Maps SuperAPI data to indexed field structure
 * @param {Object} superApiData - The SuperAPI response data
 * @returns {Object} Indexed mapping fields with values from SuperAPI
 */
export function mapTfnAndSuper(superApiData, employeeDateOfBirth) {
  // Initialize result with a copy of the indexedMapper structure
  const result = JSON.parse(JSON.stringify(indexedMapper));

  if (!superApiData) {
    return result;
  }

  const { onboarding_session_super_selection, tfn_declaration } = superApiData;

  // Map superannuation data
  mapSuperannuationData(onboarding_session_super_selection, result, employeeDateOfBirth);

  // Map TFN declaration data
  mapTfnDeclarationData(tfn_declaration, result);

  return result;
}
